"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroup = void 0;
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("../../../../common/Button/Button"));
var ReactModal_1 = __importDefault(require("../../../../common/Modal/ReactModal"));
var icons_1 = __importDefault(require("../../../../theme/icons"));
var layout_1 = __importDefault(require("../../../../theme/layout/layout"));
require("../Style/style.sass");
var DownloadFile_1 = __importDefault(require("./DownloadFile"));
function ButtonGroup(name, icon, link) {
    return (react_1.default.createElement("a", { className: 'dashboard-link', href: link },
        react_1.default.createElement(icons_1.default, { name: icon, width: 90, height: 90, className: '' }),
        react_1.default.createElement("div", { className: 'dashboard-title' }, name)));
}
exports.ButtonGroup = ButtonGroup;
function Dashboard() {
    var _a = (0, react_1.useState)(false), showModal = _a[0], setShowModal = _a[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var onClickZip = function () {
        setShowModal(true);
    };
    return (react_1.default.createElement("div", { className: 'login' },
        react_1.default.createElement("div", { className: 'left' }),
        react_1.default.createElement(layout_1.default, null,
            react_1.default.createElement("div", { className: 'logo-container' },
                react_1.default.createElement(icons_1.default, { height: 80, name: 'logo', width: 80 }),
                react_1.default.createElement(icons_1.default, { className: 'icon_black', height: 80, name: 'AcornAppIcon', width: 220 })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: 'button-container' },
                    ButtonGroup(t('guide'), 'sensitation', '/admin/guide'),
                    ButtonGroup(t('knowledge'), 'knowledge', '/admin/knowledge')),
                react_1.default.createElement("div", { className: 'button-container' }, ButtonGroup(t('report'), 'report', '/admin/report')),
                react_1.default.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'center',
                    } },
                    react_1.default.createElement(Button_1.default, { className: 'form-buttom', icon: react_1.default.createElement(icons_1.default, { name: 'zip', className: 'icon', height: 30, width: 30 }), onClick: function () { return onClickZip(); }, style: { width: 150, color: 'white', marginRight: 2 }, text: t('Download File') }),
                    react_1.default.createElement(ReactModal_1.default, { title: t('Download File'), isOpen: showModal, modalCardStyle: { width: '50%' }, isClose: function () { return setShowModal(false); }, onSaveClick: function () { return setShowModal(false); }, showSaveButton: false, labelSaveButton: t('Update Zip'), saveIconName: 'zip' },
                        react_1.default.createElement(DownloadFile_1.default, null)))))));
}
exports.default = Dashboard;
